import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TreeViewItemViewModelType from '@/ViewModels/Controls/TreeViewItemViewModel';
import LinkType from '@/Controls/Link';

export default class TreeViewItem extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private jQueryControl: JQuery;
    private isReady: JQueryDeferred<boolean>;
    private link: LinkType;
    private removeFavorite: LinkType;

    public constructor(private viewModel: TreeViewItemViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
        this.isReady = $.Deferred();
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        // <div> statt <li>, siehe TreeView.renderNode (Element liegt nicht in einem Listenkontext).
        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'treeviewitem',
            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }
                    if (this.viewModel.isExpanded() === true) {
                        states.push('expanded');
                    } else {
                        states.push('collapsed');
                    }
                    if (this.viewModel.isSelected() === true) {
                        states.push('selected');
                    } else {
                        states.push('unselected');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link, $('<a>').appendTo(this.jQueryControl));
            let tuple = this.link.getTuple();
        }

        // TODO: Sollte das nicht in ein eigenes ViewModel, welches von TreeViewItem erbt?
        if (this.viewModel.removeFavorite != null) {
            this.removeFavorite = new this.Link(this.viewModel.removeFavorite, $('<a class="removeFavoriteLink">').appendTo(this.jQueryControl));
            let tuple = this.removeFavorite.getTuple();
        }

        this.defineSubscription(this.viewModel.hasVisibleChildren, (hasVisibleChildren) => {
            let $expander = $(this.jQueryControl.parent().siblings().filter('.fancytree-expander')[0]);
            $expander.css('visibility', hasVisibleChildren ? 'visible' : 'hidden');
        })(this.viewModel.hasVisibleChildren());


        this.isReady.resolve(true);
    }
}

ComponentManager.setControl('TreeViewItem', TreeViewItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');